module.exports = __webpack_public_path__ + "img/type3.14907545.png";